import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import feedback_flow from '../../assets/img/homepage/teams/feedback_flow.png';
import customer_feedback_segmentation from '../../assets/img/homepage/teams/customer_feedback_segmentation.png';
import churn_rate_reduction from '../../assets/img/homepage/teams/churn_rate_reduction.png';
import happy_customer from '../../assets/img/homepage/teams/happy_customer.png';
// Assuming NavBar, Footer, and ImageComponent are already styled. If not, you should apply similar styled-component patterns to them.
import { AiOutlineClockCircle, AiOutlineBulb, AiOutlineInteraction, AiOutlineUsergroupAdd } from 'react-icons/ai';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Col } from 'reactstrap';

// Define styled components
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;


// Here, we add more padding to the top and bottom of each section container for extra vertical spacing.


const Features = styled.section`
  padding: 40px 20px; // Increased padding
  background-color: #f0f0f0; // Optional: add background color for visual separation
`;


const FeatureList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  .feature-icon {
    color: #0071e1;
    font-size: 24px;
  }

  .text-container {
    display: flex;
    flex-direction: column;
  }

  h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #666;
  }

`;


const CallToAction = styled.section`
  padding: 40px 20px; // Increased padding
  text-align: center;
`;

const ArticleContainer = styled.article`
  margin: 40px auto;
  max-width: 1200px;
  line-height: 1.6;
`;

const FreePlanButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: 1px solid #0071e1;

  &:hover {
    background-color: #005cbf;
    border-color: #005cbf;
  }
`;


const FlexSection = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px; /* Adjust as needed */

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Header = styled.h4`
  color: #333;
`;

const Paragraph = styled.p`
  margin: 20px 0;
`;


const Image = styled.img`
  max-width: 50%; // Increased from 45%
  height: auto;
  max-height: 250px;
  display: block;
  margin: 0 auto 20px; // Center the image and add space below
  padding: 0 20px; // Added padding for horizontal space

`;

const Title = styled.h2`
  //text-align: center;
  margin-bottom: 20px;
}
`;

// Component
const fetchTeamContent = async (team) => {
  try {
    const content = (await import(`./use-cases/${team}`)).default;
    return content;
  } catch (error) {
    console.error('Failed to load the team content.', error);
    return null; // Return null or some default content
  }
};

const UseCasesPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [teamContent, setTeamContent] = useState(null);

  useEffect(() => {
    // Extract the last part of the URL path
    const pathParts = location.pathname.split('/');
    const teamName = pathParts[pathParts.length - 1]; // Assume last part is the team name

    (async () => {
      const content = await fetchTeamContent(teamName);
      setTeamContent(content);
    })();
  }, [location]); // Reacting to changes in location
  const handleFreePlanClick = () => {
    history.push('/signup');
  };
  if (!teamContent) return <div></div>;

  return (
    <PageContainer>
      <ArticleContainer>
        <Title>{teamContent.title}</Title>
        {teamContent.sections.map((section, index) => (
          <FlexSection key={index}>
            {(!section.imageLayout || section.imageLayout === 'right') && (<>
              <div>
                <Header>{section.header}</Header>
                {section.paragraphs.map((para, pIndex) => (
                  <Paragraph key={pIndex}>{para}</Paragraph>
                ))}
              </div>
              {/* Example conditional rendering, adjust based on your actual content structure */}
              {section.imgSrc && <Image src={section.imgSrc} alt='Section visual representation' />}
            </>)}
            {(section.imageLayout === 'left') && (<>
              {section.imgSrc && <Image src={section.imgSrc} alt='Section visual representation' />}
              <div>
                <Header>{section.header}</Header>
                {section.paragraphs.map((para, pIndex) => (
                  <Paragraph key={pIndex}>{para}</Paragraph>
                ))}
              </div>
              {/* Example conditional rendering, adjust based on your actual content structure */}

            </>)}
            {(section.imageLayout === 'bottom') && (<Col>

              <div>
                <Header>{section.header}</Header>
                {section.paragraphs.map((para, pIndex) => (
                  <Paragraph key={pIndex}>{para}</Paragraph>
                ))}
                {section.imgSrc &&
                  <Image style={{ maxWidth: '100%' }} src={section.imgSrc} alt='Section visual representation' />}
              </div>
              {/* Example conditional rendering, adjust based on your actual content structure */}

            </Col>)}
          </FlexSection>
        ))}
        <Features>
          <h2 style={{ textAlign: 'center' }}>How Our Solution Helps</h2>
          <FeatureList>
            {teamContent.featuresData.map(({ id, Icon, title, description }) => (
              <FeatureItem key={id}>
                <Icon className='feature-icon' />
                <div className='text-container'>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </div>
              </FeatureItem>
            ))}
          </FeatureList>
        </Features>
        <CallToAction>
          <div>
            <h2>{teamContent.callToAction.title}</h2>
            <p>{teamContent.callToAction.subtitle}</p>
          </div>
          <FreePlanButton onClick={handleFreePlanClick}>
            Start Free
          </FreePlanButton>
        </CallToAction>
      </ArticleContainer>
    </PageContainer>
  );
};

export default UseCasesPage;